module.exports = "//a.spikex.com/sigma/frontend-ssr-web-index/_next/static/images/nft1-c300998549100b2674ce2cbce7405fbe.png";